// @flow
import { isEqual } from 'lodash';
import I18n from '../lib/i18n';
import { customerSelector } from './Customer/selectors';
import { identificationDocumentSelector } from './SignUp/Identifications/reducer';

export const formActivatePersonalInfoSelector = (state: any) => {
  const customer = customerSelector(state);
  if (!customer) {
    return {};
  }

  const identification = identificationDocumentSelector(state);

  return {
    ...customer,
    identification: identification || {},
    birthdate: customer.birthdate ? I18n.l('date.formats.short', customer.birthdate) : '',
    useAddressAsBilling: isEqual(customer.billingAddress || {}, customer.idAddress || {}),
  };
};
